import { render, staticRenderFns } from "./registrant.vue?vue&type=template&id=19a789f0&scoped=true"
import script from "./registrant.vue?vue&type=script&lang=js"
export * from "./registrant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a789f0",
  null
  
)

export default component.exports